import { useEffect, useState } from 'react'
import { apiGet } from '../utils/api'
import { useI18n } from '../i18n'

type Service = { name: string; ok: boolean; details?: string }

export default function Health() {
  const { t } = useI18n()
  const [services, setServices] = useState<Service[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string>()
  useEffect(() => {
    (async () => {
      try { const res = await apiGet('/status'); setServices(res.services) }
      catch (e: any) { setError(e?.message || 'Failed to load status') }
      finally { setLoading(false) }
    })()
  }, [])
  return (
    <div className="card">
      <h2 className="font-semibold mb-3">{t('titles.health')}</h2>
      <p className="text-sm text-gray-600 dark:text-gray-400 mb-3">{t('help.health')}</p>
      {loading ? <p>Loading…</p> : error ? <p className="text-red-600">{error}</p> : (
        <ul className="space-y-1">
          {services.map(s => (
            <li key={s.name}>
              <span className={s.ok ? 'text-green-600' : 'text-red-600'}>●</span> <strong>{s.name}</strong>
              {!s.ok && s.details ? <span className="text-xs text-gray-500"> — {s.details}</span> : null}
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}

